export const getCounterValue = (value, maxLength) => {
  if (!maxLength) {
    return String(value);
  }
  const maxNumber = Number(Array.from({
    length: maxLength
  }, () => '9').join(''));
  return maxNumber > value ? String(value) : "".concat(maxNumber, "+");
};